import { type DependencyList, useEffect, useRef } from 'react';

type ScrollOnChangeProps = { deps: DependencyList };

export const ScrollIntoViewOnChange = ({ deps }: ScrollOnChangeProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        ref.current?.scrollIntoView?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return <div ref={ref} />;
};
